import React, { FC, useState } from 'react';
import { Box, TextField, Popover } from '@mui/material';
import moment from 'moment';
import type { VoidFn, Nullable } from '../types/common';
import { DatePicker } from './DatePicker';

export interface DateFieldProps {
  date: Nullable<Date>;
  onChangeDate: VoidFn<Nullable<Date>>;
  label?: string;
}

export const DateField: FC<DateFieldProps> = ({
  date,
  onChangeDate,
  label,
}: DateFieldProps) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const openDateMenu = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDateChange = (date: Date | null) => {
    onChangeDate(date);
    handleClose();
  };

  return (
    <Box width="100%">
      <TextField
        label={label ?? 'Date'}
        value={date ? moment(date).format('MMM DD, YYYY') : 'Any date'}
        InputProps={{
          readOnly: true,
        }}
        fullWidth
        onClick={openDateMenu}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            openDateMenu(event);
          }
        }}
      />

      <Popover
        id="date-selector-popover"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box padding="24px">
          <DatePicker
            label={label}
            date={date}
            onChangeDate={handleDateChange}
          />
        </Box>
      </Popover>
    </Box>
  );
};
